module.exports = {"id":"dp4_2l1q5","text":"Protecting personal data and privacy","instructions":"Which action improves security for online payments?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"4.2","questionType":"PickOne","random":true,"options":[{"id":"dp4_2l1q5-a1","text":"Using two-factor authentication","score":1.8},{"id":"dp4_2l1q5-a2","text":"Saving card details publicly","score":0},{"id":"dp4_2l1q5-a3","text":"Ignoring payment warnings","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat4.2/l1q5.json
// module id = 1227
// module chunks = 41